import type { InstallOnelinerProvider } from '../base.js';
import { generateUniqueDelimiter } from '../../script-converters/index.js';

export class BashInstallOneliner implements InstallOnelinerProvider {
  readonly id = 'bash';
  readonly label = 'Linux / macOS';
  readonly sublabel = 'bash';
  readonly sublabelCode = "cat > file << 'EOF'";
  readonly nativeExtensions = ['.sh', '.bash', '.zsh', '.ksh'] as const;

  build(filename: string, content: string): string {
    const trimmed = content.replace(/\s+$/, '');
    const delim = generateUniqueDelimiter(trimmed, 'SCRIPT');
    return `cat > ${filename} << '${delim}'
${trimmed}
${delim}
chmod +x ${filename}
echo "Created ${filename} - run with: ./${filename}"`;
  }
}
